class Quantity extends HTMLElement {
    constructor() {
        super();
        
        this.minus = this.querySelector('#js-minus');
        this.plus = this.querySelector('#js-plus');
        this.quantity = this.querySelector("[name='quantity']");
        this.addListeners();
    }
    addListeners() {
        this.minus.addEventListener('click', this.handleMinus.bind(this));
        this.plus.addEventListener('click', this.handlePlus.bind(this));
    }
    handlePlus() {
        this.quantity.value = Number(this.quantity.value) + 1;
    }
    handleMinus() {
        if(this.quantity.value > 1){
            this.quantity.value = Number(this.quantity.value) - 1;
        }
    }
}
customElements.define("section-quanlity", Quantity);